module.exports = __webpack_public_path__ + "static/media/4u_dark.fdadb653.svg";